<template>
  <div class="login">
    <div class="layout">
      <el-card shadow="always">
        <img src="@/assets/images/ilogo.png" alt />
        <div class="content">
          <div class="form">
            <el-form
              :model="loginForm"
              :rules="rules"
              ref="loginForm"
              @submit.native.prevent="login"
            >
              <h2 class="text-left mb-2 mt-2">{{$t('auth.login.title')}}</h2>
              <el-form-item prop="email">
                <el-input v-model="loginForm.email" @keyup.enter.native="login" placeholder="Email"></el-input>
                <span class="icon">
                  <i class="fas fa-envelope"></i>
                </span>
              </el-form-item>
              <el-form-item prop="password">
                <el-input
                  v-model="loginForm.password"
                  type="password"
                  show-password
                  @keyup.enter.native="login"
                  :placeholder="$t('auth.login.password.placeHolder')"
                ></el-input>
                <span class="icon">
                  <i class="fas fa-lock"></i>
                </span>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" :disabled="isLogin" class="w-100" @click="login">
                  {{$t('auth.login.btn')}}
                  <i class="el-icon-loading" v-if="isLogin"></i>
                </el-button>
              </el-form-item>
              <div class="text-right">
                <a
                  href="forgot"
                  class="d-block hover-text-underline"
                >{{$t('auth.login.forgotPasswordBtn')}}</a>
                <router-link
                  :to="{name: 'register'}"
                  class="d-block hover-text-underline mt-1"
                >{{$t('auth.login.registerBtn')}}</router-link>
              </div>
            </el-form>
            <el-row type="flex" justify="end" class="language">
              <p @click="setLocale('en')" class="text-right mr-1">
                <i class="idc-icons icon-flag-en"></i>
              </p>
              <p @click="setLocale('vi')" class="text-right">
                <i class="idc-icons icon-flag-vi"></i>
              </p>
            </el-row>
          </div>
          <img src="@/assets/images/login.jpg" alt />
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import authServices from '@/services/auth'
export default {
  name: 'Login',
  data () {
    return {
      locale: localStorage.locale,
      isLogin: false,
      loginForm: {
        email: '',
        password: ''
      },
      rules: {
        email: [
          { required: true, message: this.$t('auth.login.email.required'), trigger: ['blur', 'change'] }
        ],
        password: [
          { required: true, message: this.$t('auth.login.password.required'), trigger: ['blur', 'change'] }
        ]
      },
      callbackURL: localStorage.getItem('callbackURL') || '/'
    }
  },
  methods: {
    setLocale (locale) {
      this.$emit('setLocale', locale)
      localStorage.locale = locale
      this.locale = locale
    },
    removeItemLocalStorage () {
      window.localStorage.removeItem('authenticated')
      window.localStorage.removeItem('access_token')
      window.localStorage.removeItem('user_info')
    },
    login () {
      if (this.isLogin) return
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.isLogin = true
          authServices.login(this.loginForm)
            .then(res => {
              this.isLogin = false
              window.localStorage.removeItem('callbackURL')
            })
            .catch(() => {
              this.isLogin = false
            })
        }
      })
    }
  },
  mounted () {
    if (!('redirect' in this.$route.query)) {
      this.removeItemLocalStorage()
    }
    if (localStorage.locale) {
      this.locale = localStorage.locale
    } else {
      this.locale = 'vi'
    }
    this.setLocale(this.locale)
  }
}
</script>

<style lang="scss" scoped>
.login {
  width: 100%;
  height: 100vh;
  background: #f8f8f8;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-card {
    width: 800px;
    border-radius: 20px;
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .form {
        width: 50%;
        .el-input {
          margin-top: 10px;
        }
        .icon {
          position: absolute;
          left: 5px;
          bottom: 0px;
          font-size: 16px;
          color: #676767;
        }
      }
      img {
        width: 45%;
      }
    }
    .language {
      p {
        i {
          cursor: pointer;
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .login {
    padding: 20px;
    .layout {
      width: 100%;
      .el-card {
        width: 100%;
      }
    }
  }
}
@media (max-width: 480px) {
  .login {
    padding: 20px;
    .layout {
      .el-card {
        .form {
          width: 100%;
        }
        img {
          display: none;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.login {
  .el-input__inner {
    border-radius: 0;
    border-left: none;
    border-top: none;
    border-right: none;
    padding-left: 30px;
  }
  .el-form-item__content {
    position: relative;
  }
  ::placeholder {
    color: #676767;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/auth/login.vue